import { render, staticRenderFns } from "./InputAmount.vue?vue&type=template&id=e4f481de&scoped=true"
import script from "./InputAmount.vue?vue&type=script&lang=js"
export * from "./InputAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f481de",
  null
  
)

export default component.exports